import useUserAuth from '../hooks/useUserAuth';

const withUserAuth = <P extends { userAuth: any }>(Component: React.FunctionComponent<P>) => (
  props: P
) => {
  const userAuth = useUserAuth();
  return <Component {...props} userAuth={userAuth} />;
};

export default withUserAuth;
